import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TransactionStatus } from '@rd/types/transaction-status.type';
import { PointsTransferState } from '../reducers/points-transfer.reducer';

export const getTransferPointsState =
  createFeatureSelector<PointsTransferState>('pointsTransfer');

export const getTransferPointsFormState = createSelector(
  getTransferPointsState,
  (state: PointsTransferState) => state.formData,
);

export const getTransferPointsLoading = createSelector(
  getTransferPointsState,
  (state: PointsTransferState) =>
    state.pointsTransfer.state === TransactionStatus.LOADING,
);

export const getTransferPointsSuccess = createSelector(
  getTransferPointsState,
  (state: PointsTransferState) =>
    state.pointsTransfer.state === TransactionStatus.SUCCESS,
);

export const getTransferPointsFail = createSelector(
  getTransferPointsState,
  (state: PointsTransferState) =>
    state.pointsTransfer.state === TransactionStatus.FAIL,
);

export const getTransferPointsError = createSelector(
  getTransferPointsState,
  (state) => state.pointsTransfer.error,
);
